import { useQuery } from '@tanstack/react-query';

import { getPackages, getUserPackage, getPackageOffers } from './package.api';

import { ApiFnReturnType } from '@/slw/shared/query-client';

export const usePackages = () =>
  useQuery<ApiFnReturnType<typeof getPackages>>({
    queryKey: ['packages'],
    queryFn: getPackages,
  });

export const useUserPackage = () =>
  useQuery<ApiFnReturnType<typeof getUserPackage>>({
    queryKey: ['user-package'],
    queryFn: getUserPackage,
  });

export const usePackageOffers = () =>
  useQuery<ApiFnReturnType<typeof getPackageOffers>>({
    queryKey: ['package-offers'],
    queryFn: getPackageOffers,
  });
